<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-card class="mb-3" title="Lider Listesi">
          <!-- <b-alert variant="warning" show class="mb-0">
            <div class="alert-body mb-2">
              <span
                ><strong>Not:</strong> Eklenecek içerik adı ve arama motoru
                bağlantı linki benzersiz olmalıdır...</span
              >
            </div>
          </b-alert> -->
          <b-button class="float-right" v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary"
            :to="`/our-leaders/create`">
            Yeni Lider Ekle
          </b-button>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <b-card class="mb-3" title="Liderlerimiz">
          <b-form>
            <b-row>
              <b-col cols="12">
                <table class="table b-table table-responsive">
                  <thead>
                    <th>#</th>
                    <th>AD SOYAD</th>
                    <th>ÜNVAN</th>
                    <th>DURUM</th>
                    <th>TARİH</th>
                    <!-- <th>ÖNİZLEME</th> -->
                    <th>İŞLEMLER</th>
                  </thead>
                  <draggable v-model="educators" class="cursor-move" tag="tbody" @change="outputData">
                    <tr v-for="educator in educators" :key="educator.id">
                      <td>{{ educator.id }}</td>
                      <td>{{ educator.firstName }} {{ educator.lastName }}</td>
                      <td>{{ educator.title }}</td>
                      <td class="text-center">
                        <b-badge v-if="educator.isDraft == false" variant="light-success">
                          Yayında
                        </b-badge>
                        <b-badge v-if="educator.isDraft == true" variant="light-warning">
                          Taslakta
                        </b-badge>
                      </td>
                      <td>{{ educator.createdAt }}</td>
                      <!-- <td>
                        <b-button-group>
                          <b-button title="Önizleme" @click="actionPreview(educator, $i18n.locale)"
                            variant="outline-primary">
                            Önizleme
                          </b-button>
                        </b-button-group>
                      </td> -->
                      <td>
                        <b-button-group class="float-right">
                          <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="outline-danger"
                            class="btn-icon rounded-circle" @click="deleteConfirmText(educator.id)">
                            <feather-icon icon="TrashIcon" />
                          </b-button>
                        </b-button-group>
                        <b-button-group class="float-right mr-2">
                          <b-button v-for="language in languages" :key="language.locale"
                            @click="action(educator, language.locale)" v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            :variant="educator.languages.find((element) => element == language.locale) ? 'outline-warning' : 'outline-secondary'"
                            :title="educator.languages.find((element) => element == language.locale) ? 'Düzenle' : 'Ekle'">
                            {{ language.locale.toUpperCase() }}
                          </b-button>
                        </b-button-group>
                      </td>
                    </tr>
                  </draggable>
                  <thead>
                    <th>#</th>
                    <th>AD SOYAD</th>
                    <th>ÜNVAN</th>
                    <th>DURUM</th>
                    <th>TARİH</th>
                    <!-- <th>ÖNİZLEME</th> -->
                    <th>İŞLEMLER</th>
                  </thead>
                </table>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import Ripple from "vue-ripple-directive";
import draggable from "vuedraggable";
import {
  BRow,
  BCol,
  BImg,
  BCard,
  BForm,
  BBadge,
  BAlert,
  BButton,
  BAvatar,
  BCardText,
  BButtonGroup,
  BListGroupItem,
  BButtonToolbar,
} from "bootstrap-vue";
import settings from '../../../settings';
import { Endpoints } from "@core/endpoints/endpoints";
const endpoints = new Endpoints();

export default {
  components: {
    BRow,
    BCol,
    BImg,
    BCard,
    BForm,
    BAlert,
    BBadge,
    BButton,
    BAvatar,
    BCardText,
    BButtonGroup,
    BListGroupItem,
    BButtonToolbar,
    draggable,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      request: [],
      languages: [],
      educators: [],
    };
  },
  watch: {},
  methods: {
    action(node, locale) {
      let translationControl = node.languages.find(
        (element) => element == locale
      );
      if (translationControl == undefined) {
        this.$router.push({
          path: `/our-leaders/create/translation/${node.slug}?targetLocale=${locale}`,
        });
      } else {
        this.$router.push({
          path: `/our-leaders/edit/${node.slugs[locale]}?targetLocale=${locale}`,
        });
      }
    },
    actionPreview(node, locale) {
      let translationControl = node.languages.find(
        (element) => element == locale
      );
      if (translationControl == undefined) {
      } else {
        window.open(`${settings.uiBaseUrl}/our-leaders/preview/${node.slugs[locale]}?hl=${locale}`, '_blank');
      }
    },
    outputData() {
      this.updateSubmit();
    },
    updateSubmit() {
      Object.entries(this.educators).forEach(([key, value]) => {
        let educatorsOrder = {
          slug: value.slug,
          order: parseInt(key),
        };
        this.request.push(educatorsOrder);
      });
      endpoints
        .putEducatorsOrder(
          { educators: this.request },
          this.$i18n.locale,
          () => { }
        )
        .then((data) => {
          this.$swal({
            icon: "success",
            title: "Güncelleme başarılı!",
            text: "Lider sıralaması güncellendi.",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getLanguages() {
      endpoints
        .getLanguages(null, this.$i18n.locale, () => { })
        .then((data) => {
          this.languages = [...data.response];
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getEducators() {
      endpoints
        .getEducators(null, this.$i18n.locale, () => { })
        .then((data) => {
          this.educators = [];
          this.educators = [...data.response];
        })
        .catch((err) => {
          console.log(err);
        });
    },
    deleteConfirmText(id) {
      this.$swal({
        title: "Sil?",
        text: "Lideri silmek istediğinize emin misiniz?",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "Vazgeç!",
        confirmButtonText: "Kaydet!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.deleteSubmit(id);
        }
      });
    },
    deleteSubmit(id) {
      endpoints
        .deleteEducators(id, this.$i18n.locale, () => { })
        .then((data) => {
          this.getEducators();
          this.$swal({
            icon: "success",
            title: "Silme başarılı!",
            text: "Lider silindi",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mounted() {
    this.getLanguages();
    this.getEducators();
  },
};
</script>
<style>
.draggable-card {
  margin-bottom: 0;
}

.draggable-card>.card-body {
  padding: 10px;
}

.draggable-card>.card-body>.card-title {
  margin-bottom: 0;
  font-size: 1rem;
}

.tree-node {
  border: 0 !important;
}
</style>
